export const newReqDefaultValues = (person) => {
  return {
    name: person?.first_name,
    surname: person?.last_name,
    mothersName: person?.mothers_name,
    email: person?.email ?? '',
    fathersName: person?.fathers_name,
    afm: person?.afm,
    profesionalData: [{ profession_id: '', profession_proof_id: '' }],
    amka: person.amka ?? '',
  };
};

const initializeMunicipalities = (request) => {
  const { municipalities, regional_units, regions } = request || {};

  return [
    ...(municipalities ? municipalities.map((m) => m.id) : []),
    ...(regional_units ? regional_units.map((ru) => ru.id) : []),
    ...(regions ? regions.map((r) => r.id) : []),
  ];
};

export const modReqDefaultValues = (request) => {
  const spatialActivity = initializeMunicipalities(request);
  return {
    name: request?.user?.first_name,
    surname: request?.user?.last_name,
    mothersName: request?.user?.mothers_name,
    fathersName: request?.user?.fathers_name,
    afm: request?.user?.afm,
    amka: request?.amka,
    email: request?.user?.email || '',
    phone: request?.phone_number,
    lastSubscription: request?.last_updated,
    certifiedUser: request?.user?.is_certified,
    protocolNumber: request?.protocol,
    spatialActivity: spatialActivity,
    ...request.initialComGroupsValues,
  };
};
